import React, { useRef, useEffect } from 'react'
import { Route, Switch } from 'react-router-dom'
import { Box } from '@mui/material'
import MerchantSidebar from '../components/Sidebar/MerchantSidebar'
import routes from '../routes'

function Restaurant(props) {
  const divRef = useRef(null)

  useEffect(() => {
    document.documentElement.scrollTop = 0
    document.scrollingElement.scrollTop = 0
    if (divRef.current) divRef.current.scrollTop = 0
  }, [])

  const getRoutes = routes =>
    routes.map((prop, key) => {
      if (prop.layout === '/restaurant') {
        return <Route path={prop.layout + prop.path} component={prop.component} key={key} />
      }
      return null
    })

  return (
    <Box sx={{ bgcolor: '#f8fafc', minHeight: '100vh' }}>
      <MerchantSidebar />
      <Box
        sx={{
          ml: { xs: 0, sm: '240px' },
          paddingTop: { xs: 8, sm: 0 },
          minHeight: '100vh',
          bgcolor: '#f8fafc'
        }}
        ref={divRef}>
        <Switch>{getRoutes(routes)}</Switch>
      </Box>
    </Box>
  )
}

export default Restaurant
